import configuration from '../../configuration';
import ODataFulogicsStore from 'fulogics-ui-core/dist/api/odata/ODataFulogicsStore';
import { createModel } from '@rematch/core';
import { iRootModel } from '../iRootModel';
import { DataSourceOptions } from 'devextreme/data/data_source';
import insertToCollectionFunc, {
    insertToCollectionPayload,
} from 'fulogics-ui-core/dist/store/helpers/insertToCollectionFunc';

export const COSOrderForwardStepPayloadODataEndpoint = `${configuration.API_BASE_URL}/odata/ForwardStepPayloads/Store`;
export const COSOrderForwardStepPayloadStore = ODataFulogicsStore(
    {
        url: COSOrderForwardStepPayloadODataEndpoint,
        key: 'id',
        keyType: 'String',
    },
    {
        createByCollectionId: (collectionId?: string) =>
            (collectionId
                ? {
                      store: COSOrderForwardStepPayloadStore,
                      reshapeOnPush: true,
                      customQueryParams: {
                          collectionId: collectionId?.toString(),
                      },
                  }
                : undefined) as DataSourceOptions,
    }
);

export type COSOrderForwardStepPayloadState = {};

export const COSOrderForwardStepPayloadModel = createModel<iRootModel>()({
    state: {} as COSOrderForwardStepPayloadState,

    effects: (dispatch) => ({
        async insertByProductIdToCollection<T>(
            payload: insertByProductIdToCollectionPayload & insertToCollectionPayload<T>
        ) {
            return insertToCollectionFunc({
                ...payload,
                //
                url: '/odata/ForwardStepPayloadsCollections/InsertPayloadItemByProductId',
                store: COSOrderForwardStepPayloadStore,
            });
        },
        async insertBySSCCListToCollection<T>(
            payload: insertBySSCCListToCollectionPayload & insertToCollectionPayload<T>
        ) {
            return insertToCollectionFunc({
                ...payload,
                //
                url: '/odata/ForwardStepPayloadsCollections/InsertPayloadItemBySSCCList'
            });
        },
        async deleteItem(payload: deleteItemPayload) {},
    }),

    // @ts-ignore
    selectors: (slice, createSelector, hasProps) => ({
        dxStore() // OrderStepForwardData
        {
            return COSOrderForwardStepPayloadStore;
        },
    }),
});

export default COSOrderForwardStepPayloadModel;

export type insertByProductIdToCollectionPayload = {
    collectionId: string;
    //
    productId: string;
    warehouseId: string;
    //
    count: number;
};
export type insertBySSCCListToCollectionPayload = {
    collectionId: string;
    //
    carrierSSCCList: string[];
};
export type deleteItemPayload = {
    itemId?: number;
};
